module.exports = __webpack_public_path__ + "static/media/logo.091b8d24.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 35
// module chunks = 1